// Navbar.js

import React from 'react';
import { Link } from 'react-router-dom';

import { Flash, Notification, SearchNormal } from 'iconsax-react';
import { useLocation } from 'react-router-dom';

const Navbar = () => {

  const location = useLocation();

  return (
    <>
      {location.pathname !== "/login" && <nav className="fixed top-0 w-screen p-3">
        <div className="container shadow-lg bg-white mx-auto flex rounded-lg p-5 justify-between items-center">
          <Link to="/" className="text-black flex items-center font-medium justify-center gap-[10px] flex-row text-lg">
            <Flash
              size="42"
              color="#0080f3"
              variant="Bulk"
              />
            MediSupport
          </Link>

          <div className="flex text-black space-x-4">
            {/* <div className='p-3 bg-gray-100 rounded-lg cursor-pointer'>
              <SearchNormal
                size="24"
                color="#697689"
                variant="Bulk"
              />
            </div> */}
            <div className='p-3 bg-gray-100 rounded-lg cursor-pointer'>
              <Notification
                size="24"
                color="#697689"
                variant="Bulk"
              />
            </div>
          </div>
        </div>
      </nav>}
    </>
  );
};


export default Navbar;
